// Watermark option lists of the vod-passthrough form. vod-default (v2) renders its settings from the
// template's format_specific_data schema and needs none of these.

export const sd_bit_profiles = [
  { 'id': 8,  'name': '8 bits / 256 distinct WM',          'max': 255 },
  { 'id': 13, 'name': '13 bits / 8192 distinct WM',        'max': 8191 },
  { 'id': 16, 'name': '16 bits / 65536 distinct WM',       'max': 65535 },
  { 'id': 24, 'name': '24 bits / 16777216 distinct WM',    'max': 16777215 },
  { 'id': 32, 'name': '32 bits / 4294967296 distinct WM',  'max': 4294967295 }
];

export const densities = [
  { 'id': 10,  'name': '10'  },
  { 'id': 20,  'name': '20'  },
  { 'id': 30,  'name': '30'  },
  { 'id': 40,  'name': '40'  },
  { 'id': 50,  'name': '50'  },
  { 'id': 60,  'name': '60'  },
  { 'id': 70,  'name': '70'  },
  { 'id': 80,  'name': '80'  },
  { 'id': 90,  'name': '90'  },
  { 'id': 100, 'name': '100' }
];

/**
 * Stardust perceptual masking modes, mirroring the embedder's `PM_MODE_*` values
 * (OFF, CLIENT_SIDE, STANDARD, JND).
 */
export const sd_pm_modes = [
  { 'id': 0, 'name': 'off' },
  { 'id': 1, 'name': 'client-side' },
  { 'id': 2, 'name': 'standard' },
  { 'id': 3, 'name': 'JND' }
];

/** The embedder's own default (`DEFAULT_PM`): standard masking. */
export const DEFAULT_SD_PM_MODE = 2;
